<div [ngClass]="classes" class="checkbox-component">
  <label>
    <input #input type="checkbox" (ngModelChange)="onChange($event)" [(ngModel)]="value" [name]="name">
    {{ label }}
  </label>
</div>
